import type { SortedField } from '../../../../../shared/source/data-contract/common';
import type { GridSortDirection } from '@mui/x-data-grid-pro';

const getSortSign = (sort: GridSortDirection): string => (sort === 'desc' ? '-' : '');

export const getSortParams = (sortedFields: readonly SortedField[]): string =>
    sortedFields.map((curItem) => `${getSortSign(curItem.direction)}${curItem.field}`).join(',');
